import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {zodResolver} from '@hookform/resolvers/zod'
import {LoaderCircle, MailCheck} from 'lucide-react'
import {useForm} from 'react-hook-form'
import {z} from 'zod'
import {Button, Input, Label} from '@/shared/ui'
import * as authApi from '../api/authApi'

const schema = z.object({
  email: z.email('Некорректный email'),
})

type FormValues = z.infer<typeof schema>

export function ForgotPasswordForm() {
  const navigate = useNavigate()
  const [sent, setSent] = useState(false)
  const [sentEmail, setSentEmail] = useState('')

  const form = useForm<FormValues>({
    resolver: zodResolver(schema),
    defaultValues: {email: ''},
  })

  const onSubmit = form.handleSubmit(async data => {
    try {
      await authApi.forgotPassword({email: data.email})
      setSentEmail(data.email)
      setSent(true)
    } catch (e) {
      const message = e instanceof Error ? e.message : 'Произошла ошибка. Попробуйте снова.'
      form.setError('root', {message})
    }
  })

  if (sent) {
    return (
      <div className="flex flex-col items-center gap-4 text-center">
        <MailCheck className="size-10 text-primary" strokeWidth={1.5} />
        <p className="text-sm text-muted-foreground">
          Ссылка для сброса пароля отправлена на{' '}
          <strong className="text-foreground">{sentEmail}</strong>.
          <br />
          Проверьте почту и перейдите по ссылке.
        </p>
        <button
          type="button"
          className="cursor-pointer text-sm text-primary underline-offset-4 hover:underline"
          onClick={() => navigate('/login')}
        >
          Вернуться к входу
        </button>
      </div>
    )
  }

  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-4" noValidate>
      <p className="text-sm text-muted-foreground">
        Введите email, привязанный к аккаунту. Мы отправим ссылку для сброса пароля.
      </p>
      <div className="space-y-2">
        <Label htmlFor="forgot-email">Email</Label>
        <Input
          id="forgot-email"
          type="email"
          autoComplete="email"
          placeholder="you@example.com"
          aria-invalid={Boolean(form.formState.errors.email)}
          {...form.register('email')}
        />
        {form.formState.errors.email && (
          <p className="text-sm text-destructive">{form.formState.errors.email.message}</p>
        )}
      </div>
      {form.formState.errors.root && (
        <p className="text-sm text-destructive">{form.formState.errors.root.message}</p>
      )}
      <Button type="submit" size="lg" className="w-full" disabled={form.formState.isSubmitting}>
        {form.formState.isSubmitting ? (
          <>
            <LoaderCircle className="size-5 animate-spin" />
            Отправка...
          </>
        ) : (
          'Отправить ссылку'
        )}
      </Button>
      <p className="text-center text-sm text-muted-foreground">
        <button
          type="button"
          className="cursor-pointer text-primary underline-offset-4 hover:underline"
          onClick={() => navigate('/login')}
        >
          Вернуться к входу
        </button>
      </p>
    </form>
  )
}
